/* eslint-disable no-console */
/* eslint-disable local-rules/no-direct-import */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  MutableRefObject,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import cx from 'classnames';
import { isMobile } from 'react-device-detect';
import ReactDOMServer from 'react-dom/server';
import { Trans, useTranslation } from 'react-i18next';
import MediaQuery from 'react-responsive';
import { useHistory, withRouter } from 'react-router';

import { selectOrderbookPrice } from 'actions/orderbook';
import {
  setChartActiveTab,
  setChartCount,
  setIsChartScrolling,
  togglePlaceOrderSection,
} from 'actions/tradingView';
import { IChartingLibraryWidget } from 'charting_library_trading_platform/charting_library';
import Button from 'components/button';
import chartStyles from 'components/chart/index.module.scss';
import { StyledButton, Wrapper } from 'components/confirm';
import Modal from 'components/modal';
import mobileWalletStyles from 'components/primaryHeaderMobile/partials/mobileWalletMenu/index.module.scss';
import { MobileModalTitle } from 'components/primaryHeaderMobile/partials/mobileWalletMenu/mobileAssetStyle';
import {
  calcPrecision,
  getProductUrlByContractType,
  handleInputBlurOnScroll,
  isFutures,
  isMoveOptions,
  isOptions,
} from 'helpers';
import { convertOrdinalDateToDDMMYY } from 'helpers/day';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { device } from 'helpers/screenSizes';
import Theme from 'helpers/theme';
import { useTheme } from 'hooks';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import { useScrollDetection } from 'hooks/useScrollDetection';
import { getExpiryList, optionsInfoSelector } from 'selectors/optionChainSeletor';
import { optionsProductsSelector } from 'selectors/optionsAnalytics/OpenInterestChangeChart';
import { userSelector } from 'selectors/otherSelectors';
import { socketActiveSelector } from 'selectors/socketSelectors';
import {
  moveOptionsProductsSelector,
  selectedProductSelector,
} from 'selectors/tradeSelectors';
import {
  chartActiveTabSelector,
  optionsChartCountSelector,
} from 'selectors/tradingViewSelector';
import { useAppDispatch, useAppSelector } from 'storeHooks';
import { CancelIcon, CrossModalCloseIcon } from 'styles/assets/icons';

import { widget } from '../../charting_library_trading_platform';
import {
  STORAGE_KEYS,
  urlContractTypeRedirection,
  OPTIONS_USER_LAYOUT_FLAG,
  STRADDLE_USER_LAYOUT_FLAG,
} from '../../constants';
import { CHART_TABS } from './chart.constants';
import { TvStyle } from './chart_style';
import { getTvSymbol } from './helper';
import OpenOrdersWidget from './openOrderWidgets';
import OpenPositionLine from './openPositionLine';
import OpenStopOrderLine from './openStopOrderWidgets';
import { DisplayOrdersSVGIconString, NewTabSvgString } from './tradingSvgIcons';
import chartConfig from './tradingViewChartConfig';
import { applyDefaultOptionsTwoPaneLayout } from './utils/optionsLayout';

interface OptionsTradingViewContainerProps {
  fullScreen: boolean;
}

const OptionsTradingViewContainer = (props: OptionsTradingViewContainerProps) => {
  const { fullScreen } = props;
  const { t } = useTranslation(['trading', 'common']);
  const { isDarkTheme, chartBackgroundColor, activeTheme } = useTheme();
  const theme = Theme(activeTheme);

  const [isChartReady, setChartReady] = useState<boolean>(false);
  const [isOpen, showModal] = useState<boolean>(false);
  const [positionSide, setPositionSide] = useState<string>('');
  const [closeData, setCloseData] = useState<any>({});
  const [showOrders, setShowOrders] = useState<boolean>(true);

  const widgetRef = useRef<null | IChartingLibraryWidget>(null);
  const orderPriceRef = useRef<null | string>(null);
  const updatePriceRef = useRef<null | Function>(null);
  const newTabUrlRef = useRef<null | string>(null);
  const tvWidgetElementRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  const showOrdersButtonRef = useRef<HTMLElement | null>(null);
  const newTabButtonRef = useRef<HTMLElement | null>(null);
  const prevLayoutCountRef = useRef<number | undefined>(undefined);
  const applyingDefaultLayoutRef = useRef<boolean>(false);

  const selectedProduct = useAppSelector(state => selectedProductSelector(state));
  const isMoveOptionsProduct = isMoveOptions(selectedProduct?.contract_type);
  const callPutProducts = useAppSelector(optionsProductsSelector);
  const moveProducts = useAppSelector(moveOptionsProductsSelector);
  const products = isMoveOptionsProduct ? moveProducts : callPutProducts;
  const socketActive = useAppSelector(socketActiveSelector);
  const user = useAppSelector(userSelector);
  const activeTab = useAppSelector(chartActiveTabSelector);
  const chartCount = useAppSelector(optionsChartCountSelector);
  const optionsInfo = useAppSelector(optionsInfoSelector);
  const containerId = isMoveOptionsProduct
    ? 'tv_chart_container_move_options'
    : 'tv_chart_container_options';

  const USER_LAYOUT_FLAG = isMoveOptionsProduct
    ? STRADDLE_USER_LAYOUT_FLAG
    : OPTIONS_USER_LAYOUT_FLAG;

  const [activeChartSymbol, setActiveChartSymbol] = useState<string | null>(
    selectedProduct?.symbol ?? null
  );
  const { whenAboveMd } = useCustomMediaQuery();

  const appDispatch = useAppDispatch();
  const history = useHistory();
  const { attachTo } = useScrollDetection(
    isScrolling => {
      appDispatch(setIsChartScrolling(isScrolling));
    },
    { debounceTime: 500 }
  );

  const isNewTab = window.location.href.indexOf('/app/tradingview') > -1;

  const currentActiveTab = activeTab;

  const findProductBySymbol = (
    productList: Record<string, any>,
    symbolToFind: string
  ) => {
    return Object.values(productList).find(product => product.symbol === symbolToFind);
  };

  const symbol = useMemo(() => {
    console.log(
      'DEBUG OPTIONS',
      selectedProduct?.symbol,
      currentActiveTab,
      selectedProduct?.spot_index?.symbol
    );
    return getTvSymbol(
      selectedProduct?.symbol,
      currentActiveTab,
      selectedProduct?.spot_index?.symbol
    );
  }, [selectedProduct?.symbol, currentActiveTab, selectedProduct?.spot_index?.symbol]);

  // TODO : refactor this using useCallback to be intitated only on product change
  const initiateCharts = () => {
    if (!socketActive) {
      return;
    }
    const savedChartProperties = localStorage.getItem(
      'tradingview.chartproperties.mainSeriesProperties'
    );

    const initialInterval = JSON.parse(savedChartProperties || '{}').interval || '60';

    console.log('DEBUG OPTIONS: Creating options widget');
    const widgetOptions = chartConfig({
      symbol,
      interval: initialInterval,
      themeObj: theme,
      activeTab: currentActiveTab,
      activeTheme: isDarkTheme ? 'dark' : 'light',
      userId: user?.id ? `${user.id}_options` : 'options',
      contractType: selectedProduct?.contract_type,
      isNewTab,
      whenBelowMd: !whenAboveMd,
      container: containerId,
      containerType: 'options',
    });

    console.log('DEBUG OPTIONS', theme, widgetOptions);

    // eslint-disable-next-line new-cap
    const tvWidget: IChartingLibraryWidget = new widget(widgetOptions);
    tvWidget?.onChartReady(() => {
      widgetRef.current = tvWidget;
      setChartReady(true);

      // apply iframe event listeners
      const iframe = tvWidgetElementRef.current?.firstElementChild as HTMLIFrameElement;
      if (iframe?.contentDocument) {
        let unsubscribeActiveChartEl;
        let unsubscribepriceAxisEl;
        // only for mobile devices
        if (!whenAboveMd) {
          window.tvChartWidget = tvWidget as any;
          // eslint-disable-next-line no-underscore-dangle
          const activeChartEl = (tvWidget.activeChart() as any)?._chartWidget?._mainDiv;
          // ? mousewheel event of activeChartEl doesnt work on price axis, so adding one on it
          const priceAxisEl = activeChartEl?.querySelector('.price-axis');
          unsubscribeActiveChartEl = attachTo(activeChartEl);
          unsubscribepriceAxisEl = attachTo(priceAxisEl, { eventTypes: ['wheel'] });
        }

        const unsubscribe = handleInputBlurOnScroll(iframe.contentDocument);
        iframe.contentDocument?.addEventListener('beforeunload', () => {
          unsubscribe();
          unsubscribeActiveChartEl?.();
          unsubscribepriceAxisEl?.();
        });
      }

      tvWidget?.activeChart()?.setSymbol(symbol);
      tvWidget
        ?.activeChart()
        ?.getPanes()[0]
        .getMainSourcePriceScale()
        ?.setAutoScale(true);
      tvWidget?.unloadUnusedCharts();

      tvWidget.applyOverrides({
        // udpates background color of the chart
        'paneProperties.backgroundGradientStartColor': chartBackgroundColor,
        'paneProperties.backgroundGradientEndColor': chartBackgroundColor,
        'mainSeriesProperties.statusViewStyle.showInterval': true,
        'mainSeriesProperties.statusViewStyle.showSymbol': true,
        'mainSeriesProperties.statusViewStyle.symbolTextSource': 'ticker',
        'paneProperties.legendProperties.showLegend': true,
        'paneProperties.legendProperties.showSeriesTitle': true,
      });

      // Apply default 2-pane layout and symbols for new users on first load only
      try {
        const hasUserLayout = localStorage.getItem(USER_LAYOUT_FLAG) === 'true';
        if (user?.id && tvWidget?.chartsCount() === 1 && !hasUserLayout) {
          applyingDefaultLayoutRef.current = true;
          applyDefaultOptionsTwoPaneLayout(
            tvWidget as any,
            selectedProduct,
            initialInterval,
            whenAboveMd
          );
          applyingDefaultLayoutRef.current = false;
        }
      } catch (e) {
        // no-op
      }

      tvWidget.headerReady().then(() => {
        if (user?.id !== '') {
          const button = tvWidget.createButton({ useTradingViewStyle: false });
          button.addEventListener('click', () =>
            setShowOrders((state: boolean) => {
              return !state;
            })
          );
          button.setAttribute('title', t('trading:header.toggleShowHidePositions'));
          button.innerHTML = ReactDOMServer.renderToStaticMarkup(
            <DisplayOrdersSVGIconString
              strokeColor={isDarkTheme ? '#E1E1E2' : '#121214'}
            />
          );
          showOrdersButtonRef.current = button;
        }

        if (!isNewTab && whenAboveMd) {
          const newTabButton = tvWidget.createButton();
          newTabButton.addEventListener('click', () =>
            newTabUrlRef.current ? window.open(newTabUrlRef.current) : null
          );
          newTabButton.setAttribute('title', t('trading:header.openInNewTab'));
          newTabButton.innerHTML = ReactDOMServer.renderToStaticMarkup(
            <NewTabSvgString strokeColor={isDarkTheme ? '#E1E1E2' : '#121214'} />
          );
          newTabButtonRef.current = newTabButton;
        }
      });
    });

    // eslint-disable-next-line consistent-return
    return widgetOptions;
  };

  const handleProductRedirect = useCallback(() => {
    const tvWidget = widgetRef.current;
    if (!tvWidget) return;

    const chartSymbol = tvWidget.activeChart()?.symbol() ?? selectedProduct?.symbol ?? '';
    setActiveChartSymbol(chartSymbol);

    const productData = findProductBySymbol(products, chartSymbol.replace('MARK:', ''));

    console.log('DEBUG FUTURES', productData);

    if (!productData) {
      appDispatch(togglePlaceOrderSection(false));
      return;
    }

    const underlyingAsset = productData?.underlying_asset?.symbol || '';
    const redirectLink = isNewTab
      ? `/tradingview/${
          chartSymbol.includes('MARK:') ? CHART_TABS.MARK_CHART : CHART_TABS.PRICE_CHART
        }/${urlContractTypeRedirection(productData?.contract_type)}/${
          productData?.underlying_asset?.symbol
        }/${chartSymbol}`
      : getProductUrlByContractType(
          productData?.contract_type,
          underlyingAsset,
          chartSymbol.replace('MARK:', '')
        );

    appDispatch(togglePlaceOrderSection(true));

    if (chartSymbol.includes('MARK:')) {
      appDispatch(setChartActiveTab(CHART_TABS.MARK_CHART));
    } else if (chartSymbol.includes('.DE')) {
      appDispatch(setChartActiveTab(CHART_TABS.INDEX_PRICE_CHART));
    } else {
      appDispatch(setChartActiveTab(CHART_TABS.PRICE_CHART));
    }

    history.push(redirectLink);
  }, [selectedProduct, products, isNewTab, appDispatch, history]);

  useEffect(() => {
    prevLayoutCountRef.current = chartCount;
  }, [chartCount]);

  useEffect(() => {
    const tvWidget = widgetRef.current;

    // ! there is no unsubscribe function returned from below subscriptions, so not unsubscribing
    if (isChartReady && tvWidget) {
      tvWidget
        ?.activeChart()
        ?.onIntervalChanged()
        ?.subscribe(null, () => {
          tvWidget
            ?.activeChart()
            ?.getPanes()[0]
            .getMainSourcePriceScale()
            ?.setAutoScale(true);
        });

      // Auto-save subscription
      tvWidget?.subscribe('onAutoSaveNeeded', () => {
        tvWidget?.saveChartToServer(
          () => console.log('DEBUG OPTIONS: saveChartToServer'),
          e => console.error('DEBUG OPTIONS: saveChartToServer error', e),
          {
            chartName: `${symbol}_options`,
          }
        );
      });

      tvWidget
        ?.activeChart()
        ?.onSymbolChanged()
        ?.subscribe(null, () => {
          handleProductRedirect();
        });

      // Active chart change subscription
      tvWidget?.subscribe('activeChartChanged', () => {
        handleProductRedirect();
        tvWidget
          ?.activeChart()
          ?.onSymbolChanged()
          ?.subscribe(null, () => {
            handleProductRedirect();
          });
      });

      // Layout change subscription
      tvWidget?.subscribe('layout_changed', () => {
        console.log('DEBUG FUTURES: Layout changed', tvWidget?.chartsCount());
        if (tvWidget?.chartsCount() === 1) {
          tvWidget
            ?.activeChart()
            ?.setSymbol(
              getTvSymbol(
                selectedProduct?.symbol ?? '',
                currentActiveTab,
                selectedProduct?.spot_index?.symbol ?? ''
              )
            );
        }
        appDispatch(
          setChartCount({
            containerType: 'options',
            chartCount: tvWidget?.chartsCount(),
          })
        );
        if (!applyingDefaultLayoutRef.current) {
          try {
            localStorage.setItem(USER_LAYOUT_FLAG, 'true');
          } catch (err) {
            // no-op
          }
        }
        trackMixpanelEvent('Chart Layout Changed - Trade - Chart', {
          is_mobile: isMobile,
          current_chart_layout: prevLayoutCountRef.current || 1,
          selected_chart_layout: tvWidget?.chartsCount(),
          widget_type: 'options',
        });
      });

      // Cross-hair and mouse events (desktop only)
      if (whenAboveMd) {
        tvWidget
          ?.activeChart()
          .crossHairMoved()
          .subscribe(null, ({ price }: { price: number }) => {
            const precision = calcPrecision(selectedProduct?.tick_size);
            orderPriceRef.current = price.toFixed(precision);
          });

        tvWidget?.subscribe('mouse_up', () => {
          updatePriceRef.current?.();
        });
      }
    }
  }, [isChartReady]);

  // useEffect to update newTabUrlRef
  useEffect(() => {
    const route = window.location.pathname.replace('/app', '').replace('/trade', '');
    newTabUrlRef.current = `/app/tradingview/${currentActiveTab}${route}`;
  }, [currentActiveTab, selectedProduct?.id]);

  // reset Chart layout if optionsInfo changes , solves expiry s=issues
  useEffect(() => {
    if (widgetRef.current && socketActive && isChartReady) {
      const count = widgetRef.current?.chartsCount();
      // for loop to remove chart if chart?.symbol is not found in products
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < count; i++) {
        const chart = widgetRef.current?.chart(i);
        const expiryList = getExpiryList(optionsInfo, 'BTC'); // expiryList mostly same for both BTC and ETH
        // expiryList = [
        //   {
        //     "value": "2025-10-16T12:00:00Z",
        //     "label": "16th Oct 2025"
        //   },
        //   {
        //     "value": "2025-10-17T12:00:00Z",
        //     "label": "17th Oct 2025"
        //   },
        //   {
        //     "value": "2025-10-18T12:00:00Z",
        //     "label": "18th Oct 2025"
        //   },
        //   {
        //     "value": "2025-10-24T12:00:00Z",
        //     "label": "24th Oct 2025"
        //   },
        //   {
        //     "value": "2025-10-31T12:00:00Z",
        //     "label": "31st Oct 2025"
        //   },
        //   {
        //     "value": "2025-11-28T12:00:00Z",
        //     "label": "28th Nov 2025"
        //   }
        // ]
        // chart?.symbol()?.split('-')[3] = 281125 (28th Nov 2025)
        // const searchedChartProductIndex = products.findIndex(
        //   product =>
        //     chart?.symbol() === product.symbol ||
        //     chart?.symbol() === `MARK:${product.symbol}`
        // );
        if (
          // chart?.symbol should have C-BTC || P-BTC || C-ETH || P-ETH , in order to determine its a options product
          chart?.symbol() &&
          (chart?.symbol().includes('C-') || chart?.symbol().includes('P-'))
        ) {
          // function to check if chart?.symbol()?.split('-')[3] is present in expiryList, if not present then product is expired
          const isNotExpired = expiryList.some(
            expiry =>
              convertOrdinalDateToDDMMYY(expiry.label) === chart?.symbol()?.split('-')[3]
          );
          if (!isNotExpired) {
            // find product in products list where settlement time is first element of expiryList
            const product = products.find(p => p.settlement_time === expiryList[0].value);
            if (product) {
              widgetRef.current?.chart(i)?.setSymbol(`MARK:${product.symbol}`);
            }
          }
        }
      }
    }
  }, [optionsInfo, isChartReady]);

  // to initially mount the chart
  useEffect(() => {
    initiateCharts();
    return () => {
      window.tvChartWidget?.remove();
      delete window.tvChartWidget;
      window.sessionStorage.removeItem(STORAGE_KEYS.CHART_LAST_SUBSCRIPTION_ID);
    };
  }, []);

  // change symbol when selected product changes
  useEffect(() => {
    if (selectedProduct && socketActive && widgetRef.current && isChartReady) {
      widgetRef.current?.activeChart()?.setSymbol(symbol ?? '');

      widgetRef.current
        ?.activeChart()
        ?.getPanes()[0]
        .getMainSourcePriceScale()
        ?.setAutoScale(true);

      appDispatch(
        setChartCount({
          containerType: 'options',
          chartCount: widgetRef?.current?.chartsCount(),
        })
      );

      if (
        currentActiveTab === CHART_TABS.PRICE_CHART ||
        currentActiveTab === CHART_TABS.MARK_CHART
      ) {
        setShowOrders(true);
      }

      if (
        currentActiveTab === CHART_TABS.PRICE_CHART ||
        (currentActiveTab === CHART_TABS.MARK_CHART &&
          (isFutures(selectedProduct?.contract_type) ||
            isOptions(selectedProduct?.contract_type)))
      ) {
        updatePriceRef.current = () => {
          appDispatch(
            selectOrderbookPrice({
              price: orderPriceRef.current,
              productId: selectedProduct?.id,
              fromTradingView: user?.preferences?.tradeToOrderBookedPriceFill,
            })
          );
        };
      }
    }
  }, [selectedProduct, currentActiveTab, isChartReady, symbol]);

  // Apply theme changes
  useEffect(() => {
    if (selectedProduct && socketActive && widgetRef.current && isChartReady) {
      widgetRef.current?.changeTheme(isDarkTheme ? 'dark' : 'light');

      if (showOrdersButtonRef.current) {
        showOrdersButtonRef.current.setAttribute(
          'title',
          t('trading:header.toggleShowHidePositions')
        );
        showOrdersButtonRef.current.innerHTML = ReactDOMServer.renderToStaticMarkup(
          <DisplayOrdersSVGIconString strokeColor={isDarkTheme ? '#E1E1E2' : '#121214'} />
        );
      }

      if (newTabButtonRef.current) {
        newTabButtonRef.current.setAttribute('title', t('trading:header.openInNewTab'));
        newTabButtonRef.current.innerHTML = ReactDOMServer.renderToStaticMarkup(
          <NewTabSvgString strokeColor={isDarkTheme ? '#E1E1E2' : '#121214'} />
        );
      }
    }
  }, [activeTheme]);

  const onClose = (dispatchClosePosition, openPosition) => {
    setPositionSide(openPosition?.size > 0 ? 'Long' : 'Short');
    showModal(true);
    setCloseData({
      dispatchClosePosition,
      openPosition,
    });
  };

  const onClickYes = () => {
    closeData.dispatchClosePosition(closeData.openPosition);
    setPositionSide('');
    showModal(false);
    setCloseData({});
  };

  const isChartOrdersVisible = showOrders && user?.id !== '' && widgetRef?.current;

  return (
    <>
      <TvStyle
        ref={tvWidgetElementRef}
        id={containerId}
        className={cx(
          'tv_chart_container',
          fullScreen ? 'mobile-full-screen w-100vh' : ''
        )}
      />
      {isChartOrdersVisible && (
        <>
          <OpenStopOrderLine
            widgetRef={widgetRef}
            isNewTab={isNewTab}
            isChartReady={isChartReady}
            currentActiveTab={currentActiveTab}
            activeChartSymbol={activeChartSymbol}
            containerType="options"
          />
          <OpenOrdersWidget
            widgetRef={widgetRef}
            isNewTab={isNewTab}
            isChartReady={isChartReady}
            currentActiveTab={currentActiveTab}
            activeChartSymbol={activeChartSymbol}
          />
          <OpenPositionLine
            widgetRef={widgetRef}
            isNewTab={isNewTab}
            onClose={onClose}
            isChartReady={isChartReady}
            currentActiveTab={currentActiveTab}
            activeChartSymbol={activeChartSymbol}
          />
        </>
      )}

      <MediaQuery query={device.down.md}>
        <Modal
          isOpen={isOpen}
          onRequestClose={showModal}
          shouldCloseOnOverlayClick
          shouldCloseOnEsc={false}
          className="footer-common-modal"
          classOverlayName="footer-common-modal-overlay"
        >
          <Wrapper>
            <MobileModalTitle className={mobileWalletStyles['modal-title']}>
              <button
                type="button"
                data-testid="close-modal"
                onClick={() => showModal(false)}
              >
                <CancelIcon />
              </button>
            </MobileModalTitle>
            <div className="confirm-text">
              <Trans
                i18nKey="common:close_position"
                values={{
                  product: closeData.openPosition?.product_symbol,
                  side: positionSide,
                }}
              >
                <span className={`side-${positionSide.toLowerCase()}`} />
                <span className="product-name" />
              </Trans>
            </div>
            <div className={chartStyles['yes-button']}>
              <Button
                data-testid="mobile-close-position-yes-button"
                style={{
                  margin: '20px',
                  width: '90%',
                }}
                primary
                onClick={onClickYes}
                className="mobile-close-button"
              >
                {t('common:market_close')}
              </Button>
            </div>
          </Wrapper>
        </Modal>
      </MediaQuery>
      <MediaQuery query={device.up.md}>
        <Modal
          isOpen={isOpen}
          onRequestClose={showModal}
          style={{
            padding: 0,
            zIndex: 99999,
            content: {
              top: '0 !important',
              height: '100%',
              overflow: 'hidden',
            },
          }}
        >
          <Wrapper className="close-position">
            <span
              data-testid="j3avSnRHf2RdfF8vnaI44"
              className="close-icon"
              onClick={() => showModal(false)}
              role="button"
              onKeyPress={() => {}}
              tabIndex={0}
            >
              <CrossModalCloseIcon />
            </span>
            <div className="confirm-text">
              <Trans
                i18nKey="common:close_position"
                values={{
                  product: closeData.openPosition?.product_symbol,
                  side: positionSide,
                }}
              >
                <span className={`side-${positionSide.toLowerCase()}`} />
                <span className="product-name" />
              </Trans>
            </div>
            <div className="buttons">
              <StyledButton
                data-testid="desktop-close-position-yes-button"
                className="confirm-ok-button"
                primary
                onClick={onClickYes}
              >
                {t('common:market_close')}
              </StyledButton>
              <StyledButton
                data-testid="desktop-close-position-cancel-button"
                className="confirm-no-button"
                primary
                onClick={() => showModal(false)}
              >
                {t('common:cancel')}
              </StyledButton>
            </div>
          </Wrapper>
        </Modal>
      </MediaQuery>
    </>
  );
};

export default withRouter(OptionsTradingViewContainer);
